import { useEffect } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app/AppSidebar";
import { LotterySelector } from "@/components/app/LotterySelector";
import { LotteryProvider } from "@/hooks/use-lottery-selection";
import { useTheme } from "@/hooks/use-theme";
import { NotificationBell } from "@/components/app/NotificationBell";
import AppSeo from "@/components/app/AppSeo";
import PromoBanner from "@/components/PromoBanner";

const AppLayout = () => {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  // Se o usuário veio do fluxo de Google OAuth com um plano pago pendente,
  // redireciona para /planos para concluir o checkout. Caso contrário,
  // mantém o usuário no /app (Dashboard) — comportamento padrão pós-login.
  useEffect(() => {
    try {
      const tier = sessionStorage.getItem("lt:pendingTier");
      if (tier === "pro" || tier === "premium") {
        sessionStorage.removeItem("lt:pendingTier");
        navigate(`/planos?tier=${tier}&autostart=1`, { replace: true });
      }
    } catch {
      /* ignore */
    }
  }, [navigate]);

  return (
    <LotteryProvider>
      <SidebarProvider>
        <AppSeo />
        <div className="flex min-h-screen w-full bg-background">
          <AppSidebar />
          <div className="flex flex-1 flex-col">
            <PromoBanner />
            <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-lt-border bg-background/95 px-4 backdrop-blur">
              <div className="flex items-center gap-3">
                <SidebarTrigger aria-label="Abrir menu lateral" />
                <LotterySelector />
              </div>
              <div className="flex items-center gap-2">
                <Link to="/quem-somos" className="hidden md:inline-block text-[12px] text-lt-cream3 hover:text-foreground transition-colors px-2">
                  Quem somos
                </Link>
                <Link to="/alerta" className="hidden md:inline-block text-[12px] text-lt-cream3 hover:text-foreground transition-colors px-2">
                  Alerta
                </Link>
                <Link to="/termos" className="hidden md:inline-block text-[12px] text-lt-cream3 hover:text-foreground transition-colors px-2">
                  Termos
                </Link>
                <NotificationBell />
                <button
                  onClick={toggleTheme}
                  className="rounded-md border border-lt-border bg-transparent px-2.5 py-1.5 text-base text-lt-cream3 transition-all hover:border-lt-cream3 hover:text-foreground"
                  aria-label="Alternar tema"
                >
                  {theme === "dark" ? "☀" : "🌙"}
                </button>
              </div>
            </header>
            <main className="flex-1 p-4 md:p-6">
              <Outlet />
            </main>
          </div>
        </div>
      </SidebarProvider>
    </LotteryProvider>
  );
};

export default AppLayout;
